import { motion } from 'framer-motion';
import { Calendar } from 'lucide-react';
import SupportAgentImg from '../../../../../assets/App_Img/landing_support_agent.png';

const DemoCtaCard = ({ whatsappLink }) => {
  return (
    <motion.div
      initial={{ opacity: 0, x: 20 }}
      whileInView={{ opacity: 1, x: 0 }}
      viewport={{ once: true }}
      transition={{ duration: 0.5, delay: 0.2 }}
      className="flex-1 bg-[#f0fdfa] rounded-3xl p-6 sm:p-8 border border-[#067978]/10 flex flex-col sm:flex-row items-center gap-5 sm:gap-6 shadow-[0_4px_20px_rgba(6,121,120,0.05)] overflow-hidden relative text-center sm:text-left"
    >
      <div className="w-24 h-24 sm:w-28 sm:h-28 md:w-36 md:h-36 flex-shrink-0 relative">
        <img
          src={SupportAgentImg}
          alt="Support Agent"
          className="w-full h-full object-contain transform scale-110 sm:scale-125"
          style={{ mixBlendMode: 'darken' }}
        />
      </div>

      <div className="flex flex-col space-y-3 items-center sm:items-start">
        <h3 className="text-lg md:text-xl font-semibold text-[#1a2b49] leading-tight">
          Need help creating Your voucher?
        </h3>
        <p className="text-[#475569] font-normal text-xs sm:text-[13px]">
          Book a 5-minute demo.
        </p>
        <a
          href={whatsappLink}
          target="_blank"
          rel="noopener noreferrer"
          className="bg-[#067978] hover:bg-[#05605f] text-white px-5 py-2.5 rounded-lg font-medium flex items-center justify-center gap-2 w-full sm:w-fit transition-all hover:shadow-lg hover:-translate-y-0.5 text-sm"
        >
          <Calendar size={16} />
          Book Demo
        </a>
      </div>
    </motion.div>
  );
};

export default DemoCtaCard;
